import {ToastOptions} from 'ng2-toastr';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomOption extends ToastOptions {
  showCloseButton = true;
  dismiss = 'auto';
  maxShown = 3;
  positionClass = 'toast-bottom-left';
  enableHTML = true;
}



// WEBPACK FOOTER //
// ./src/app/utils/toast-options.ts